import { Button, Typography } from '@mui/material'

import { PageBuilderIcon } from '#/store/providers/Pagebuilder/Components/Icon'
import Palette from '#/styles/Palette'

export type ResponseOptionGroupFilter = {
  name: string
  type: 'option-group'
  title: string
  visible?: boolean
  current?: string
  icon: any
  next?: string
}

type Props = {
  title: string
  onChange: (value?: string) => void
  id?: string
} & ResponseOptionGroupFilter

export default function OptionGroup(props: Props) {
  const { icon, id, next, onChange, title } = props

  const handleChange = () => onChange(next)

  const sx = {
    '& .MuiButton-startIcon': { marginRight: '5px' },
    'backgroundColor': Palette.gray.light[100],
    'borderRadius': 1,
    'color': Palette.gray.self[800],
    'px': 1.5,
  }

  return (
    <Button
      size="small"
      sx={sx}
      onClick={handleChange}
      startIcon={<PageBuilderIcon size="small" value={icon} />}
      id={id}
    >
      <Typography variant="h6" sx={{ fontWeight: '400' }}>
        {title}
      </Typography>
    </Button>
  )
}
